import { render, staticRenderFns } from "./OperationWarning.vue?vue&type=template&id=350b572c&scoped=true&"
import script from "./OperationWarning.vue?vue&type=script&lang=js&"
export * from "./OperationWarning.vue?vue&type=script&lang=js&"
import style0 from "./OperationWarning.vue?vue&type=style&index=0&id=350b572c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b572c",
  null
  
)

export default component.exports